import axios from "../../config/axiosConfig";
import { CREATE_PRODUCTION_PURCHASE, GET_PRODUCTION_PURCHASES, PRODUCTION_PURCHASE_REQUEST, UPDATE_PRODUCTION_PURCHASE, DELETE_PRODUCTION_PURCHASE, PRODUCTION_PURCHASE_FAILURE } from "../types";

export const getProductionPurchases = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_PURCHASE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/production-purchase/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PRODUCTION_PURCHASES, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_PURCHASE_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_PURCHASE_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createProductionPurchase = (production) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: PRODUCTION_PURCHASE_REQUEST });
      return axios.post("/production-purchase/add", production,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_PRODUCTION_PURCHASE, payload: response.data });
        } else {
          dispatch({
            type: PRODUCTION_PURCHASE_FAILURE,
            error: "Production create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_PURCHASE_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_PURCHASE_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateProductionPurchase = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_PURCHASE_REQUEST });
      const { auth } = getState();
      return axios.put("/production-purchase/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }
      }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_PRODUCTION_PURCHASE,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: PRODUCTION_PURCHASE_FAILURE,
            error: "Production code update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_PURCHASE_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_PURCHASE_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteProductionPurchase = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: PRODUCTION_PURCHASE_REQUEST });
      return axios.delete(`/production-purchase/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_PRODUCTION_PURCHASE, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_PURCHASE_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_PURCHASE_FAILURE, error: error.message });
      throw error;
    }
  };
};